import { render, staticRenderFns } from "./FactoryManagementMenu.vue?vue&type=template&id=ac0f794c&scoped=true&"
import script from "./FactoryManagementMenu.vue?vue&type=script&lang=ts&"
export * from "./FactoryManagementMenu.vue?vue&type=script&lang=ts&"
import style0 from "./FactoryManagementMenu.vue?vue&type=style&index=0&id=ac0f794c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0f794c",
  null
  
)

export default component.exports